import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useBankAccounts = () => useQuery({ queryKey: [`bank-accounts`], queryFn: async () => {
    const callback = await API.get(`/bank_accounts`)
    return callback?.data
}, staleTime: 60000, gcTime: 1000 * 60 * 30 })

export default useBankAccounts